import { ActivityLog } from "../api-model";

export class Team extends ActivityLog {
    id?: string;
    teamCd?: string
    teamName: string;
    delflg?: boolean;
    checked?: boolean = false; 
}